import React from 'react'
import PropTypes from 'prop-types'

import moment from 'moment'
import { Feed, Modal } from 'semantic-ui-react'

import Button from 'Components/StandardButton'
import ChangelogEvent from 'Components/ChangelogModal/ChangelogEvent'

import events from 'Global/changelog'
import icons from 'Global/icons'

const ChangelogModal = ({ close }) => {
  const mappedEvents = events
    .sort((a, b) => moment.utc(b.date).diff(moment.utc(a.date)))
    .map(event => <ChangelogEvent date={event.date} items={event.items} key={event.version} title={event.title} version={event.version} />)

  return (
    <Modal onClose={close} open={true} size="small">
      <Modal.Header icon={icons['user']}>Changelog</Modal.Header>

      <Modal.Content>
        <Feed>{mappedEvents}</Feed>
      </Modal.Content>

      <Modal.Actions>
        <Button content="Close" icon={icons['close']} onClick={close} />
      </Modal.Actions>
    </Modal>
  )
}

ChangelogModal.propTypes = {
  close: PropTypes.func.isRequired,
}

export default ChangelogModal
